import {
    ColoursObj,
    getContrastYIQ,
    Typography,
} from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import i18n from '../../i18n/i18next'
import { bs } from '../../state/bound.store'

export const SeePast = () => {
    return (
        <Stack
            alignItems="center"
            position="relative"
            width={'100%'}
            style={{
                top: '-128px',
            }}
        >
            <Box
                onClick={() => {
                    bs().setPast(true)
                }}
                sx={{
                    backdropFilter: 'blur(6px)',
                    borderRadius: '8px',
                    padding: '4px 8px',
                }}
            >
                <Typography
                    variant="bodySubtext"
                    color={getContrastYIQ(ColoursObj.backgrounds.primary)}
                >
                    {i18n.t('home.seePast')}
                </Typography>
            </Box>
        </Stack>
    )
}
